import type { AxiosRequestConfig, AxiosResponse } from 'axios';

import client from 'api/client';

export type DocumentTemplateCategory =
    | 'ADMINISTRATIVE'
    | 'EDUCATION'
    | 'EMPLOYMENT'
    | 'FAMILY_RELATIONSHIP_AND_CUSTODY'
    | 'FINANCIAL'
    | 'GOVERNMENT_FORM'
    | 'IDENTITY_AND_CIVIL_STATUS'
    | 'LANGUAGE'
    | 'MEDICAL_AND_SECURITY'
    | 'NOMINATION';

export interface DocumentTemplateSearchHit {
    /** `document_template.id` */
    id: number;
    /** `null` for global templates. */
    service_provider_id: number | null;
    /** Already localized from the JWT `language_setting`. */
    name: string;
    /** Already localized from the JWT `language_setting`. */
    description: string | null;
    name_en: string;
    name_fr: string | null;
    description_en: string | null;
    description_fr: string | null;
    is_form: boolean;
    document_type: 'ORGANIZATION' | 'USER' | 'SERVICES_ALL' | 'SERVICES_SELECTED';
    category: DocumentTemplateCategory | null;
    /**
     * `true` when the template is already on this case. Only meaningful when
     * `application_id` was sent. May be `null` otherwise — do not treat that
     * as “not on the case”.
     */
    already_exists: boolean | null;
}

export interface DocumentTemplateSearchParams {
    country: string;
    q: string;
    applicationId?: string | number;
    limit?: number;
}

/**
 * Catalog typeahead across this firm’s templates and global templates.
 * `q` must be non-empty after trim. Do not send `service_name`.
 */
export function search(
    params: DocumentTemplateSearchParams,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<DocumentTemplateSearchHit[]>> {
    return client.get<DocumentTemplateSearchHit[]>('/document-templates/search', {
        ...customConfig,
        params: {
            country: params.country,
            q: params.q,
            ...(params.limit != null ? { limit: params.limit } : {}),
            ...(params.applicationId != null ? { application_id: params.applicationId } : {}),
            ...(customConfig?.params || {}),
        },
    });
}
